import { v4 as uuidv4 } from "uuid";
import i18n from "../../../i18n";
import { Export1CProcedurePluginView } from "./Export1CProcedurePluginView";

const t = (value: string) => i18n.t("sidePanel." + value);

export const Export1CProcedureTab = (): ITab => {
    return {
        id: uuidv4(),
        title: t("files.submenu.export1CProcedure"),
        plugin: "export_1c_procedure_plugin",
        view: {
            content: <Export1CProcedurePluginView />,
        },
    };
};
